import { createColorVariable as r, createBorder as c, createOutline as o } from "./highrise530.mjs";
function a(e) {
  return {
    color: "var(--base-white)",
    border: c(e, 300),
    textColor: r(e, 700),
    rippleColor: r(e, 600),
    // Hover
    colorHover: r(e, 50),
    borderHover: c(e, 300),
    textColorHover: r(e, 800),
    // Focus
    colorFocus: r(e, 50),
    borderFocus: c(e, 300),
    textColorFocus: r(e, 800),
    outlineFocus: o(e, 100),
    // Pressed
    colorPressed: r(e, 100),
    borderPressed: c(e, 300),
    textColorPressed: r(e, 900),
    // Disabled
    colorDisabled: "var(--base-white)",
    borderDisabled: c(e, 200),
    textColorDisabled: r(e, 300)
  };
}
export {
  a as createSecondaryTheme
};
